<template>
    <multiselect
        v-model="unsubscribeReason"
        :options="activeUnsubscribeReasons"
        track-by="uuid"
        label="name"
        :multiple="false"
        :allowEmpty="!!allowEmpty"
        placeholder="Motivo de baja"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange"></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from 'vuex';

    export default {
        name: "ClientUnsubscribeReasonSelector",
        components: {
            Multiselect
        },
        props: {
            value: Object,
            allowEmpty: Boolean
        },
        data: function () {
            return {
                unsubscribeReason: null
            }
        },
        mounted() {
            this.$store.dispatch('loadUnsubscribeReasons');
            this.unsubscribeReason = this.evaluateValue(this.value);
        },
        computed: {
            ...mapGetters([
                'activeUnsubscribeReasons'
            ])
        },
        methods: {
            evaluateValue(value) {
                if (
                    !!value
                    && !!value.uuid
                ) {
                    return this.findUnsubscribeReasonByUuid(value.uuid);
                } else {
                    return null;
                }
            },
            findUnsubscribeReasonByUuid(uuid) {
                if (!!this.activeUnsubscribeReasons) {
                    return this.activeUnsubscribeReasons.find(reason => (reason.uuid === uuid));
                } else {
                    return null;
                }
            },
            notifyChange(reason) {
                this.$emit('input', reason);
            }
        },
        watch: {
            value: function () {
                this.unsubscribeReason = this.evaluateValue(this.value);
            },
            activeUnsubscribeReasons: function () {
                this.unsubscribeReason = this.evaluateValue(this.value);
            }
        }
    }
</script>

<style scoped>

</style>